import React from "react";
import Modal from 'react-modal';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import {
    FacebookShareButton,
    LineShareButton,
} from "react-share";
import { Button } from 'react-bootstrap';
import { toast } from "react-toastify";

import classNames from 'classnames/bind';
import style from './index.module.css';
const cx = classNames.bind(style);

interface ModelProps {
    isOpen: boolean;
    handleClose: () => void;
    istop6K: boolean | null;
    isPrize: boolean | null;
    invitationCode: string | null;
}

const ShareModel: React.FC<ModelProps> = ({
    isOpen,
    handleClose,
    istop6K,
    invitationCode,
    isPrize,
}) => {
    const shareUrl = `${process.env.REACT_APP_URL}#/home?inviteCode=${invitationCode ? invitationCode : ""}`
    const title = invitationCode ? '歡迎一起參加權證模擬交易抽大獎,我的邀請碼:' + `${invitationCode}` : "";

    return (
        <Modal
            isOpen={isOpen}
            contentLabel=""
            onRequestClose={handleClose}
            className="ShareModal"
            overlayClassName="Overlay"
            shouldCloseOnOverlayClick={false}
            ariaHideApp={false}
        >
            <>
                <div className={cx("modalTitleWrap")}>
                    <div className={cx("modalTitle")}>
                        <img src={require('../../static/image/modelCoin.png')} />
                    </div>
                    <div className={cx("modalRight")}>
                        <button className={cx("modalCloseButton")} onClick={handleClose} >
                            <span className={cx("modalCloseButtonFont")}>&times;</span>
                        </button>
                    </div>
                </div>

                {isPrize === true ? (
                    <>
                        <div style={{ textAlign: 'center' }}>
                            <div className={cx("modalContent")} style={{ fontSize: "18px", color: "#000", fontWeight: "bolder" }}>
                                {/* <img width='30%' src={require('../../static/image/GetLinetext.png')} alt="Get Line Text" /> */}
                                <h3>感謝您的參與！</h3>
                            </div>
                            <div className={cx("modalContent", "sharebtn", 'flex-wrap', 'mt-3')} style={{ textAlign: 'center', color: "#000" }}>
                                
                            </div>
                            <div className={cx("text-lightblue")} style={{ textAlign: 'center' }}>
                            新會員獎的得獎名單將2025/01/13公布
                            於網站中公告
                            </div>
                            <div className={cx("modalContent", "shareText", "text-black")} style={{ textAlign: 'center' }}>
                            活動期間內還有多重豐富獎項，在等你！
                            快快邀請好友一起參加吧！
                            </div>
                            <p style={{ fontSize: '10px' }}>※活動參與資格，依活動辦法規定之內容為準。</p>
                        </div>
                    </>
                    //
                ) : null 
                // (
                //     <>
                //         <div style={{ textAlign: 'center' }}>
                //             <div className={cx("modalContent", "sharebtn", 'flex-wrap', 'mt-3')} style={{ textAlign: 'center' }}>
                //                 <h3>哎呀！晚了一步！ <br />早鳥獎勵已兌換完畢</h3>
                //             </div>
                //             <div className={cx("modalContent", "shareText", "text-black")} style={{ textAlign: 'center' }}>
                //                 別灰心~活動期間還有多項萬元大獎等你來拿喔！
                //             </div>
                //         </div>
                //     </>
                // )
                }
                <div className='sharemodalFoot'>
                    <div className={cx("wrap")}>
                        <div className={cx("shareurlText")}>專屬連結<br />{shareUrl}</div>
                    </div>
                    <div className={cx("wrap")}>
                        <CopyToClipboard text={shareUrl} onCopy={() => {
                            toast.info(`已複製連結！`, {
                                position: "top-right",
                                autoClose: 1300,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                            });
                        }} >
                            <Button className={cx("copyurl")}>
                                複製連結
                            </Button>
                        </CopyToClipboard>
                    </div>
                    <div className={cx("wrap")}>
                        <FacebookShareButton
                            className={cx("share-btn")}
                            url={shareUrl}
                            quote={title}
                        >
                            <span className={cx("icon")}>
                                <img src={require('../../static/image/FB.png')} />
                            </span>
                        </FacebookShareButton>

                        <LineShareButton
                            className={cx("share-btn")}
                            url={shareUrl}
                            title={title}
                        >
                            <span className={cx("icon")}>
                                <img src={require('../../static/image/LINE.png')} />
                            </span>
                        </LineShareButton>
                    </div>
                </div>
            </>
        </Modal>
    );
}

export default ShareModel;
